module.exports = __webpack_public_path__ + "static/media/shuttleSafetyIcon.3ddb0364.png";